(() => {
    // app/scripts/common/component/details.js
    !window.customElements.get("accordion-component") && window.customElements.define("accordion-component", class extends HTMLElement {
      constructor() {
        super();
        if (this.hasAttribute("data-open-screen") || this.hasAttribute("data-close-screen")) {
          const { debounceTime } = theme;
          const debounce = debounceTime((e) => this.changeState(e), 300);
          window.addEventListener("resize", debounce.bind(this));
        }
        this.querySelectorAll("a").forEach((link) => {
          link.addEventListener("click", (e) => {
            e.stopPropagation();
          });
        });
        setTimeout(() => {
          this.querySelector(".jsNavContent, details") && this.init();
        }, 0);
      }
      connectedCallback() {
        this.changeState();
      }
      init() {
        this.details = this.querySelector("details, .jsDetails");
        this.summary = this.details.querySelector(".jsNav, :scope > summary");
        this.close = this.details.querySelector(".js-details-close");
        this.content = this.details.querySelector(".jsNavContent, :scope > *:not(summary)");
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.summary.addEventListener("click", (e) => this.onClick(e));
        if (this.close) {
          this.close.closest("details") == this.details && this.close.addEventListener("click", (e) => this.onClick(e));
        }
        this.details.classList.add("accordion-initialized");
        if (this.details.tagName != "DETAILS") {
        }
      }
      onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.details.style.overflow = "hidden";
        if (this.isClosing || !this.details.setOpen) {
          this.open();
        } else if (this.isExpanding || this.details.setOpen) {
          this.shrink();
        }
      }
      shrink() {
        this.isClosing = true;
        const summaryPosition = window.getComputedStyle(this.summary).position;
        const startHeight = `${this.details.offsetHeight}px`;
        const endHeight = `${summaryPosition == "absolute" ? 0 : this.summary.offsetHeight}px`;
        if (this.animation) {
          this.animation.cancel();
        }
        this.details.classList.add("is-closing");
        this.animation = this.details.animate({
          height: [startHeight, endHeight]
        }, {
          duration: 400,
          easing: "ease-out"
          // fill: 'both'
        });
        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => this.isClosing = false;
      }
      open() {
        this.details.style.height = `${this.details.offsetHeight}px`;
        this.details.setOpen = true;
        this.details.classList.add("is-opening");
        this.isExpanding = true;
        const summaryPosition = window.getComputedStyle(this.summary).position;
        const summaryHeight = summaryPosition == "absolute" ? 0 : this.summary.offsetHeight;
        const startHeight = `${this.details.offsetHeight}px`;
        const endHeight = `${summaryHeight + this.content.offsetHeight}px`;
        if (this.animation) {
          this.animation.cancel();
        }
        const s = Math.abs(+startHeight.replace("px", "") - endHeight.replace("px", ""));
        const v = s / 50;
        this.animation = this.details.animate({
          height: [startHeight, endHeight]
        }, {
          duration: 400,
          //v*100,
          easing: "ease-out"
          // fill: 'both'
        });
        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => this.isExpanding = false;
      }
      onAnimationFinish(open) {
        this.details.setOpen = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.details.classList.remove("is-closing", "is-opening");
        this.details.style.height = this.details.style.overflow = "";
      }
      changeState() {
        this.hasAttribute("data-open-screen") && window.matchMedia(this.getAttribute("data-open-screen")).matches && (this.querySelector("details").open = true);
        this.hasAttribute("data-close-screen") && window.matchMedia(this.getAttribute("data-close-screen")).matches && (this.querySelector("details").open = false);
      }
    });
  })();
  